var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanylogo6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#589541}.st1{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect2984",
    className: "st0",
    d: "M64 0h384c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Bird_1_",
    className: "st1",
    d: "M256 136c-53.3 0-93.3 13.4-133.3 53.4H56s0 20 26.7 26.7c-12 16.3-26.7 44.7-26.7 66.6 0 55 38.3 93.3 93.3 93.3 31.2 0 61.7-17.5 80-40l26.7 40 26.7-40c18.3 22.5 48.8 40 80 40 55 0 93.3-38.3 93.3-93.3 0-21.9-14.7-50.2-26.7-66.7 26.7-6.7 26.7-26.7 26.7-26.7h-66.7c-40-40-80-53.3-133.3-53.3zm0 13.3c66.7 0 106.7 40 106.7 40-53.4 0-106.7 66.7-106.7 133.4 0-66.7-53.3-133.3-106.7-133.3 0-.1 40-40.1 106.7-40.1zM149.3 216c36.8 0 66.7 29.8 66.7 66.7 0 36.8-29.8 66.7-66.7 66.7s-66.7-29.8-66.7-66.7c.1-36.8 29.9-66.7 66.7-66.7zm213.4 0c36.8 0 66.7 29.8 66.7 66.7 0 36.8-29.8 66.7-66.7 66.7S296 319.5 296 282.7c0-36.8 29.8-66.7 66.7-66.7zm-213.4 26.7c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zm213.4 0c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zM149.3 256c14.7 0 26.7 12 26.7 26.7s-12 26.7-26.7 26.7-26.7-11.9-26.7-26.7c.1-14.7 12-26.7 26.7-26.7zm213.4 0c14.7 0 26.7 12 26.7 26.7s-12 26.7-26.7 26.7-26.7-12-26.7-26.7 11.9-26.7 26.7-26.7zm-213.4 13.3c-7.4 0-13.3 6-13.3 13.3 0 7.4 6 13.3 13.3 13.3 7.4 0 13.3-6 13.3-13.3.1-7.3-5.9-13.3-13.3-13.3zm213.4 0c-7.4 0-13.3 6-13.3 13.3 0 7.4 6 13.3 13.3 13.3 7.4 0 13.3-6 13.3-13.3 0-7.3-6-13.3-13.3-13.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanylogo6);
export default __webpack_public_path__ + "static/media/companylogo6.cec01b6009269f30859caf6434934125.svg";
export { ForwardRef as ReactComponent };